import HTTP from "./http.service";
import Translation from "./translation.service";

var EligibilityService = {};

EligibilityService.idType = () => {
  let config = {
    method: "get",
    url: "/eligibility/type",
    headers: {
      "Virgin-Lang": Translation.getCurrentLanguage()
    }
  };
  return HTTP(config);
};

EligibilityService.availableNationalities = id_type => {

  let config = {
    method: "get",
    url: `/eligibility/available_nationalities?id_type=${id_type}&random=${Date.parse(new Date())}`,
    headers: {
      "Virgin-Lang": Translation.getCurrentLanguage()
    }
  };
  return HTTP(config);
};

EligibilityService.availableSaudiCities = () => {
  let config = {
    method: "get",
    url: "/eligibility/available_saudi_cities",
    headers: {
      "Virgin-Lang": Translation.getCurrentLanguage()
    }
  };
  return HTTP(config);
};

EligibilityService.checkEligibility = data => {
  let config = {
    method: "post",
    url: "/eligibility/check_eligibility",
    data: data
  };
  return HTTP(config);
};

EligibilityService.isEligibleForPostpaid = () => {
  let config = {
    method: "post",
    url: "/eligibility/is_eligible_for_postpaid",
    headers: {
      "Virgin-Lang": Translation.getCurrentLanguage()
    },
    data: {}
  };
  return HTTP(config);
};

EligibilityService.isEligibleForPostpaidPost = (data) => {
  let config = {
    method: "post",
    url: "/eligibility/is_eligible_for_postpaid",
    data: data,
    headers: {
      "Virgin-Lang": Translation.getCurrentLanguage()
    }
  };
  return HTTP(config);
};

EligibilityService.availableGenderAndMaritalStatus = () => {
  let config = {
    method: "get",
    url: "/eligibility/marital_statuses_and_genders",
  };
  return HTTP(config);
};

export default EligibilityService;
